import './instrument';
import React, { StrictMode } from 'react';

import * as Sentry from '@sentry/react';

// import 'whatwg-fetch';
// import 'promise-polyfill/src/polyfill';
import 'nodep-date-input-polyfill';

import { createRoot } from 'react-dom/client';
import {
    createBrowserRouter,
    RouterProvider,
} from 'react-router-dom';

import ImageSelector from '@src/components/image-selector';
import Error403 from '@src/components/error/Error403';
import Login from '@src/containers/login';
import App from '@src/containers/app';
import { GetSignedUrlFile } from '@src/custom';

import './css/metlife_css/index.scss';
import './index.scss';

// Create the Sentry-wrapped router (call this AFTER Sentry.init())
const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const router = sentryCreateBrowserRouter([
    {
        path: '/attachments/:id/download',
        element: <GetSignedUrlFile />,
    },
    {
        path: '/forbidden',
        element: <Error403 />,
    },
    {
        path: '/login',
        element: <Login />,
    },
    {
        path: '/image-selector',
        element: <ImageSelector />,
    },
    {
        path: '*',
        element: <App />,
    },
], { basename: '/' });

// Omit onCaughtError: Sentry.ErrorBoundary already captures boundary errors.
// Wiring both would double-report to Sentry.
const root = createRoot(document.querySelector('#root'), {
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
        console.error('Uncaught error', error, errorInfo.componentStack);
    }),
    onRecoverableError: Sentry.reactErrorHandler((error, errorInfo) => {
        console.error('Recoverable error', error, errorInfo.componentStack);
    }),
});

root.render(
    <StrictMode>
        <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
            <RouterProvider router={router} />
        </Sentry.ErrorBoundary>
    </StrictMode>,
);
